<template>
  <el-dialog class="dialog-edit-cost" :title="title" :visible.sync="visible" width="500px">
    <ConfigForms ref="form" labelWidth="140px" contentWidth="220px" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';

const formItems = [
  { type: 'text', label: '模型名称', required: true, key: 'modelName' },
  { type: 'number', label: '分组倍率', required: true, key: 'groupMillion' },
  { type: 'number', label: '提示倍率', required: true, key: 'promptMillion' },
  { type: 'number', label: '完成倍率', required: true, key: 'completionMillion' },
  { type: 'number', label: '提示词价格 $', required: true, key: 'promptCost' },
  { type: 'number', label: '完成词价格 $', required: true, key: 'completionCost' },
  { type: 'number', label: '模型倍率', required: true, key: 'modelMillion' },
  { type: 'number', label: '充值倍率', required: true, key: 'rechargeMillion' },
  { type: 'number', label: '用户折扣', required: true, key: 'userMillion' },
]
export default {
  name: 'EditProductConfig',
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑产品配置' : '新增产品配置'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      if (row) {
        // TODO：参数待完善
        this.formData = { ...row }
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-cost {
  /deep/ .el-date-editor.el-input {
    width: 200px;

  }
}
</style>
